/** Strip a trailing parenthetical note from an item card description. */
export const cleanItemDescription = (description: string): string =>
  description.replace(/\s*\([^)]*\)\s*$/, "");
